import { all, fork, put, takeEvery } from 'redux-saga/effects';
import ScannedDocument from '../../../models/ScannedDocument';
import callToAPI from '../../../utils/callToAPI';
import * as Api from '../../api/scannedDocuments';
import * as types from './types';

function* getScannedDocument({ payload }) {
  yield callToAPI({
    apiCall: Api.getScannedDocument,
    successResponseCode: 200,
    errorType: types.GET_SCANNED_DOCUMENT_ERROR,
    *callback(response) {
      yield put({
        type: types.GET_SCANNED_DOCUMENT_SUCCESS,
        payload: new ScannedDocument(response.data),
      });
    },
    payload,
  });
}

function* updateScannedDocument({ payload }) {
  yield callToAPI({
    apiCall: Api.updateScannedDocument,
    successResponseCode: 200,
    errorType: types.UPDATE_SCANNED_DOCUMENT_ERROR,
    *callback(response) {
      yield put({
        type: types.UPDATE_SCANNED_DOCUMENT_SUCCESS,
        payload: new ScannedDocument(response.data),
      });
    },
    payload,
  });
}

function* createScannedDocument({ payload }) {
  yield callToAPI({
    apiCall: Api.createScannedDocument,
    successResponseCode: 200,
    errorType: types.CREATE_SCANNED_DOCUMENT_ERROR,
    *callback(response) {
      yield put({
        type: types.CREATE_SCANNED_DOCUMENT_SUCCESS,
        payload: new ScannedDocument(response.data),
      });
    },
    payload,
  });
}

function* deleteScannedDocument({ payload }) {
  yield callToAPI({
    apiCall: Api.deleteScannedDocument,
    successResponseCode: 204,
    errorType: types.DELETE_SCANNED_DOCUMENT_ERROR,
    *callback() {
      yield put({ type: types.DELETE_SCANNED_DOCUMENT_SUCCESS, payload });
    },
    payload,
  });
}
function* watcherUpdateScannedDocument() {
  yield takeEvery(types.UPDATE_SCANNED_DOCUMENT_REQUEST, updateScannedDocument);
}

function* watcherGetScannedDocument() {
  yield takeEvery(types.GET_SCANNED_DOCUMENT_REQUEST, getScannedDocument);
}

function* watcherCreateScannedDocument() {
  yield takeEvery(types.CREATE_SCANNED_DOCUMENT_REQUEST, createScannedDocument);
}

function* watcherDeleteScannedDocument() {
  yield takeEvery(types.DELETE_SCANNED_DOCUMENT_REQUEST, deleteScannedDocument);
}

export default function* rootSaga() {
  yield all([
    fork(watcherUpdateScannedDocument),
    fork(watcherGetScannedDocument),
    fork(watcherCreateScannedDocument),
    fork(watcherDeleteScannedDocument),
  ]);
}
